export enum DataSourceProcessStatus {
  NotProcessed = 'NotProcessed',
  Processed = 'Processed',
  Processing = 'Processing',
}